import React from 'react';

export default function Tab(props) {
  return (<div className="tab">
    {props.children}
  </div>);
}



/** WEBPACK FOOTER **
 ** ./src/components/Tab.js
 **/